import {CommonModule} from "@angular/common";
import {FormsModule} from "@angular/forms";
import {NgModule} from "@angular/core";


import {CollapseMenuComponent} from "./collapse-menu/collapse-menu.component";
import {RecentProjectsComponent} from "./recent-projects/recent-projects.component";
import {FullScreenComponent} from "./full-screen/full-screen.component";
import { SettingMenuComponent } from "./setting-menu/setting-menu.component";

import {ActivitiesComponent} from "./activities/activities.component";
import {ActivitiesMessageComponent} from "./activities/activities-message/activities-message.component";
import {ActivitiesNotificationComponent} from "./activities/activities-notification/activities-notification.component";
import {ActivitiesTaskComponent} from "./activities/activities-task/activities-task.component";
import {HeaderComponent} from "./header.component";

import {UtilsModule} from "@app/shared/utils/utils.module";
import {PipesModule} from "@app/shared/pipes/pipes.module";
import {I18nModule} from "@app/shared/i18n/i18n.module";
import {UserModule} from "@app/shared/user/user.module";
import {BsDropdownModule, PopoverModule, ModalModule} from "ngx-bootstrap";
import { LayoutService } from "@app/shared/layout/layout.service";
// import { LayoutService } from "../layout.service";
// import { SettingMenuComponent } from "./setting-menu/setting-menu.component";
import { ApplicationComponent } from "./application-menu/application-menu.component";
import { ApplicationMenuService } from "./application-menu/application-menu.service";
import { PostItModule } from "../../postIt/postIt.module";
import { TutorialComponent } from "../header/tutorial/tutorial.component";
import  {GraphqlService}  from '@app/shared/layout/header/tutorial/graphql.service';
import { companyListComponent } from "./company-list/company-list.component";
import { JqueryUiModule } from "@app/shared/ui/jquery-ui/jquery-ui.module";
import { CartComponent } from "./cart/cart.component";

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    BsDropdownModule,
    UtilsModule,
    PipesModule,
    I18nModule,
    UserModule,
    PopoverModule,
    ModalModule.forRoot(),
    PostItModule,
    JqueryUiModule
  ],
  declarations: [
    ActivitiesMessageComponent,
    ActivitiesNotificationComponent,
    ActivitiesTaskComponent,
    RecentProjectsComponent,
    SettingMenuComponent,
    FullScreenComponent,
    CollapseMenuComponent,
    ActivitiesComponent,
    HeaderComponent,
    ApplicationComponent,
    TutorialComponent,
    companyListComponent,
    CartComponent
  ],
  exports: [
    HeaderComponent
  ],
  providers: [
    ApplicationMenuService,GraphqlService
  ]
})
export class HeaderModule{}
